<template>
  <v-card flat class="px-3 quizCard d-flex flex-column">
    <VideoPlayerQuizModal />

    <v-dialog v-model="isDeleteDialogOpen" max-width="500px">
      <v-card>
        <v-card-title class="body-bold-medium mb-3 mt-2">{{
          $t('message.ai.quiz.removeModal.removeQuestion')
        }}</v-card-title>
        <v-card-text>
          <span class="body-regular-small textType6--text">{{
            $t('message.ai.quiz.removeModal.removeQuestionDescription')
          }}</span>
          <br />
          <span class="body-regular-small textType6--text">{{
            $t('message.ai.quiz.removeModal.removeQuestionDescription2')
          }}</span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <base-btn
            class="my-4 mr-2"
            type="tertiary"
            @click="isDeleteDialogOpen = false"
          >
            {{ $t('message.cancel') }}</base-btn
          >
          <base-btn type="danger" text @click="confirmRemoveQuestion">
            {{ $t('message.remove') }}</base-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="d-flex flex-column">
      <v-col cols="12" class="body-bold-smaller py-0">
        <a type="primary" size="xsmall" @click="beforeLeave">
          <v-icon size="12" class="backIcon">mdi-arrow-left</v-icon>
          {{ $t('message.actions.return') }}
        </a>
      </v-col>

      <v-col class="pt-1 py-0">
        <span class="body-bold-medium">Quiz</span>
      </v-col>

      <v-col cols="12" class="py-0">
        <span class="body-regular-smaller textType6--text pageDescription">
          {{ $t('message.ai.quiz.quizDescription') }}
          <a target="_blank" type="secondary" :href="quizArticle">
            <span>
              {{ $t('message.embedModal.knowMore') }}
            </span>
            <v-icon size="12">mdi-open-in-new</v-icon>
          </a>
        </span>
      </v-col>

      <div :class="{ 'd-none': isLoading }" class="">
        <v-col cols="12" class="pl-3 pt-6">
          <span class="body-bold-medium">Panda AI - Quiz</span>
        </v-col>
        <div class="d-flex">
          <v-col class="pa-0 pl-3 py-4 pb-3" cols="6">
            <p class="mb-0 body-regular-small">
              {{ $t('message.ai.quiz.activeQuiz') }}
            </p>
            <span class="body-regular-smaller textType6--text"
              >{{ $t('message.ai.quiz.enableQuiz') }}
            </span>
          </v-col>

          <v-col cols="6" class="d-flex align-center justify-end">
            <v-switch
              v-model="isEnabledInPlayer"
              @click="toggleActivation"
              :disabled="preventToggleQuickly"
              class="my-0 py-0 ml-3 align-center"
              compact
              hide-details
            ></v-switch>
          </v-col>
        </div>
      </div>

      <v-col v-if="isEnabledInPlayer" cols="12" class="mt-2 px-3">
        <v-divider />
      </v-col>

      <v-col v-if="isEnabledInPlayer" cols="12" class="pl-3 pt-5">
        <span class="body-bold-medium">{{
          $t('message.ai.quiz.quizQuestions')
        }}</span>
      </v-col>

      <draggable v-if="isEnabledInPlayer" v-model="questions" handle=".handler">
        <v-col
          cols="12"
          v-for="(question, index) in questions"
          :key="question.id"
          :class="{ handler: !isMobileBreakpoint }"
          class="pa-1 questionsRow"
          @click="handleEditModal(question, index + 1)"
        >
          <v-row no-gutters>
            <v-card class="ml-2 mr-2 d-flex" flat width="100%">
              <v-col
                cols="10"
                class="pa-0"
                style="cursor: pointer"
                @click="handleExpandQuestion(index)"
              >
                <v-row class="fill-height" no-gutters align="center">
                  <img
                    :class="{ handler: isMobileBreakpoint }"
                    class="svgColor"
                    src="@/assets/dragIcon.svg"
                  />
                  <!-- mostrar o index da pergunta -->
                  <span class="ml-2 body-regular-smaller indexIndicator">{{
                    index + 1
                  }}</span>
                  <span
                    style="max-width: calc(95% - 50px)"
                    :title="question.enunciate"
                    class="ml-4"
                  >
                    <span class="body-regular-small">
                      {{ question.enunciate }}
                    </span>
                    <br />
                    <span class="body-regular-smaller textType6--text">
                      R:
                      {{
                        question.options.find((option) => option.correct).text
                      }}
                    </span>
                  </span>
                </v-row>
              </v-col>
              <v-col cols="2" class="justify-end d-flex pa-0">
                <span
                  class="align-center d-flex mr-2 iconElement"
                  @click="handleEditModal(question, index + 1)"
                >
                  <v-icon size="16">panda-edit</v-icon>
                </span>
                <v-menu offset-y bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="iconElement" icon v-bind="attrs" v-on="on">
                      <v-icon size="16">panda-menu-action</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item @click="openDeleteDialog(index)">
                      <v-list-item-title
                        ><span class="error--text body-bold-smaller">{{
                          $t('message.ai.quiz.removeModal.removeQuestion')
                        }}</span></v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-card>
          </v-row>
        </v-col>
      </draggable>
      <div
        :class="{ 'd-none': isLoading }"
        v-if="isEnabledInPlayer"
        style="height: 50px"
        class="ml-4 mt-2"
      >
        <base-btn type="secondary" size="xsmall" @click="addQuestion">
          {{ $t('message.ai.quiz.addQuestion') }}
        </base-btn>
      </div>

      <portal to="actions-footer">
        <div
          class="d-flex flex-row actions-row"
          :class="{ mobileSpace: isMobileBreakpoint }"
          v-if="isEnabledInPlayer"
        >
          <v-spacer></v-spacer>
          <base-btn
            :disabled="!hasChanges || loadingOrder"
            type="tertiary"
            :tooltip="!hasChanges ? $t('message.noChanges') : ''"
            @click="cancelChanges"
            tooltipMargin="me-3"
          >
            {{ $t('message.actions.cancel') }}
          </base-btn>

          <base-btn
            :disabled="!hasChanges"
            :loading="loadingOrder"
            :tooltip="!hasChanges ? $t('message.noChanges') : ''"
            @click="updateQuestionsOrder(questions)"
            class="ms-3"
            keepWidthOnLoading
          >
            {{ $t('message.actions.publish') }}
          </base-btn>
        </div>
      </portal>
    </div>

    <unsaved-changes-modal />

    <template v-if="isLoading">
      <v-container>
        <v-row class="d-flex mt-2">
          <v-col cols="12">
            <v-skeleton-loader
              class="border loader-width"
              type="chip"
            ></v-skeleton-loader>
          </v-col>
          <v-col cols="12">
            <v-skeleton-loader
              class="border loader-width"
              type="image"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import _ from 'lodash'
import i18n from '@/translations/lang'
import playerApi from '@/services/playerApi.js'
import videosApi from '@/services/videosApi.js'
import aiworkflowApi from '@/services/aiworkflowApi'
import draggable from 'vuedraggable'
import VideoPlayerQuizModal from './VideoPlayerQuizModal.vue'
import UnsavedChangesModal from '@/components/UnsavedChangesModal.vue'

export default {
  name: 'VideoPlayerQuiz',
  components: { VideoPlayerQuizModal, draggable, UnsavedChangesModal },
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      isEnabledInPlayer: false,
      preventToggleQuickly: false,
      isDeleteDialogOpen: false,
      questionIndexToDelete: null,
      questions: '',
      videoConfig: {},
      initialQuestionsVal: '',
      initialEditingQuestionValue: null,
      beingEditedQuestion: {
        enunciate: '',
        options: [{ text: '', corrrect: true }],
      },
      question: { enunciate: '', options: [{ text: '', corrrect: true }] },
      isEditing: false,
      questionIndex: 0,
      expandedQuestionIndex: -1,
      questionCorrectIndex: 0,
      loadings: {
        updatingQuestions: false,
        removingQuestion: false,
        removingQuestionIndex: 0,
      },
      loadingOrder: false,
      isUpdateQuestion: false,
      editMode: false,
    }
  },
  created() {
    this.checkEnabledItems()
  },
  mounted() {
    this.handleData()
    this.$root.$on('quizUpdateQuestions', (questions) => {
      this.questions = questions
      this.initialQuestionsVal = questions
    })
    this.$root.$on('discardChanges', () => {
      this.handleBack()
    })
  },
  beforeDestroy() {
    this.$root.$off('quizUpdateQuestions')
    this.$root.$off('openVideoQuizModal')
  },
  computed: {
    ...mapState({
      video: (state) => state.video.video,
      hasData: (state) => state.video.aiWorkFlow?.data,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    hasChanges() {
      return !_.isEqual(this.questions, this.initialQuestionsVal)
    },
    locale() {
      return this.$i18next.resolvedLanguage
    },
    quizArticle() {
      if (this.locale === 'en') {
        return 'https://help.pandavideo.com/en-us/article/panda-ai-quizquestions-1ll72ly/'
      }
      if (this.locale === 'es') {
        return 'https://help.pandavideo.com/es/article/panda-ai-quizpreguntas-jcr1fa/'
      }
      return 'https://help.pandavideo.com/pt-br/article/panda-ia-quizperguntas-651o7k/'
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    ...mapMutations('video', ['UPDATE_VIDEO_CONFIG']),
    ...mapActions('video', ['aiWorkFlowStatus', 'handleFetchAiWorkFlowData']),
    handleEditModal(selectedQuestion, index) {
      const quizCard = document.querySelector('.quizCard')
      quizCard.classList.add('pt-6')
      this.$root.$emit('openVideoQuizModal', {
        questions: this.questions,
        selectedQuestion,
        index,
      })
    },
    addQuestion() {
      const quizCard = document.querySelector('.quizCard')
      quizCard.classList.add('pt-6')
      this.$root.$emit('addVideoQuizOption', {
        questions: this.questions,
      })
    },
    openDeleteDialog(index) {
      this.questionIndexToDelete = index
      this.isDeleteDialogOpen = true
    },
    confirmRemoveQuestion() {
      if (this.questionIndexToDelete !== null) {
        this.removeQuestion(this.questionIndexToDelete)
      }
      this.isDeleteDialogOpen = false
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.ai.quiz.removeModal.removeQuestionSnackbar'),
        type: 'success',
      })
    },
    cancelEditing() {
      this.isEditing = false
      if (this.isUpdateQuestion) {
        this.questions[this.questionIndex] = this.initialEditingQuestionValue
      }
    },
    async removeQuestion(indexToRemove) {
      this.loadings.removingQuestion = true
      this.loadings.removingQuestionIndex = indexToRemove
      const newArray = [
        ...this.questions.slice(0, indexToRemove),
        ...this.questions.slice(indexToRemove + 1),
      ]
      await this.updateQuestions(newArray)
      this.loadings.removingQuestion = false
      this.loadings.removingQuestionIndex = 0
      this.questionIndexToDelete = null
    },
    addOption() {
      if (this.beingEditedQuestion.options.length > 4) return
      this.beingEditedQuestion.options.push({ text: '', correct: false })
    },
    removeOption(optionIndex) {
      if (this.beingEditedQuestion.options.length < 2) return
      if (this.beingEditedQuestion.options[optionIndex].correct) {
        this.questionCorrectIndex = 0
      }
      this.beingEditedQuestion.options.splice(optionIndex, 1)
    },
    handleQuestion(question, index) {
      this.isUpdateQuestion = false
      this.beingEditedQuestion = {
        enunciate: '',
        options: [{ text: '', corrrect: true }],
      }
      if (question?.enunciate) {
        this.initialEditingQuestionValue = question
        this.beingEditedQuestion = question
        this.questionIndex = index
        this.isUpdateQuestion = true
      }
      this.isEditing = true
    },
    async handleSaveQuestion() {
      if (
        this.questionIndex >= 0 &&
        this.questionIndex < this.questions.length &&
        this.isUpdateQuestion
      ) {
        this.questions[this.questionIndex] = this.beingEditedQuestion
      }
      let newQuestions = this.questions.map((question) => question)
      if (!this.isUpdateQuestion) {
        newQuestions.push(this.beingEditedQuestion)
      }
      this.loadings.updatingQuestions = true
      await this.updateQuestions(newQuestions)
      this.isEditing = false
      this.loadings.updatingQuestions = false
    },
    async updateQuestions(newQuestions) {
      const videoId = this.$route.params.id
      const aiData = {
        video_id: videoId,
        questions: newQuestions,
      }
      try {
        let res = await aiworkflowApi.updateAiWorkFlowData(aiData)
        this.questions = res.data.questions
        this.initialQuestionsVal = res.data.questions
      } catch (e) {
        console.error('e', e)
      }
    },
    async updateQuestionsOrder(newQuestions) {
      try {
        this.loadingOrder = true
        await this.updateQuestions(newQuestions)
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: i18n.t('message.changesSaved'),
          type: 'success',
        })
      } finally {
        this.loadingOrder = false
      }
    },
    async cancelChanges() {
      this.questions = _.cloneDeep(this.initialQuestionsVal)
    },
    handleKnowMore() {
      const link = this.getQuizLink()
      window.open(link, '_blank')
    },
    async handleData() {
      let { pullzone_name, video_external_id } = this.video
      try {
        const { questions: questionsFromApi } = await this.handleFetchAiWorkFlowData({
          pullzone_name,
          video_external_id,
        })
        const hydratedQuestions = questionsFromApi.map((question, index) => {
          return {
            ...question,
            id: `question-${Date.now()}-${index}`,
          }
        })

        this.questions = hydratedQuestions
        this.initialQuestionsVal = _.cloneDeep(hydratedQuestions) // Use o clone profundo aqui

      } catch (error) {
        console.error(error)
      }
    },
    handleExpandQuestion(index) {
      if (this.expandedQuestionIndex === index) {
        return (this.expandedQuestionIndex = -1)
      } else {
        this.expandedQuestionIndex = index
        this.questionCorrectIndex = this.questions[index].options.findIndex(
          (option) => option.correct
        )
      }
    },

    handleAddQuestion() {
      this.questions.push({
        enunciate: '',
        options: [{ text: '', correct: true }],
      })
    },
    beforeLeave() {
      if (this.hasChanges) {
        this.$root.$emit('unsavedChangesModal')
      } else {
        this.handleBack()
      }
    },
    handleClose() {
      this.$root.$emit('renameModalClosed')
      this.open = null
    },
    async toggleActivation() {
      this.preventToggleQuickly = true
      this.videoConfig['questions'] = this.isEnabledInPlayer
      await playerApi.updateAiVideoConfig(this.video.id, this.videoConfig)
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.changesSaved'),
        type: 'success',
      })
      this.preventToggleQuickly = false
    },
    async checkEnabledItems() {
      try {
        const {
          data: { config },
        } = await videosApi.getAVideo(this.video.id)
        this.UPDATE_VIDEO_CONFIG(config)
        this.isEnabledInPlayer = ((config || {}).ai || {}).questions || false
        this.videoConfig = (config || {}).ai || {}
        this.isLoading = false
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.right-answer {
  color: #1b5e20;
  background-color: #c8e6c9;
}

.iconElement {
  border-radius: 4px;
  max-height: 24px;
  max-width: 24px;
  min-width: 24px;
  min-height: 24px;
  align-self: center;
  justify-content: center;
  display: flex;
  background: varFigma(neutral-100-white);
}

.iconElement:hover {
  background: varFigma(neutral-90);
}

::v-deep .v-btn--icon.v-size--default {
  height: auto;
  width: 36px;
}

.svgColor {
  cursor: grab;
}

.bg-dark {
  .svgColor {
    filter: brightness(0) saturate(100%) invert(100%) sepia(59%) saturate(1451%)
      hue-rotate(179deg) brightness(86%) contrast(78%);
  }
}

.questionsRow:hover {
  cursor: pointer;
  background: varFigma(neutral-99);
  .fill-height {
    background: varFigma(neutral-99);
  }
  .justify-end {
    background: varFigma(neutral-99);
  }
}

::v-deep .v-icon:focus::after {
  opacity: 0 !important;
}

::v-deep .v-icon:hover::after {
  opacity: 0 !important;
}

::v-deep .v-btn:focus::before {
  opacity: 0 !important;
}

::v-deep .v-btn:hover::before {
  opacity: 0 !important;
}

.indexIndicator {
  display: flex;
  width: 24px;
  height: 16px;
  margin-top: 2px;
  padding: 0px var(--spacing-02, 4px);
  justify-content: center;
  align-items: center;
  border-radius: var(--spacing-03, 8px);
  background: varFigma(neutral-95-lightest);
}

.no-list-style {
  list-style-type: none;
  padding-left: 0;
  font-weight: 400;
}

.enunciate {
  font-weight: 500;
}

.mobileSpace {
  padding-right: 80px !important;
}

.scroll-container {
  max-height: 500px;
  overflow-y: auto;
}
</style>
